module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hips_info":"HiPS Info"},"ja":{"hips_info":"HiPS情報"}}')
  delete Component.options._Ctor
}
